import { FleetTripsTable } from '@/products/fleet/features/fleet-trips-table';

export function FleetVehicleTripsTab({ vehicleId }: { vehicleId: string }) {
  return <FleetTripsTable vehicleId={vehicleId} />;
}
